<template>
  <div class='oversea'>
    <div><img src="/static/images/activty/overseawarehouse/oversea_app/app_oversea_01.jpg"></div>
    <div><img src="/static/images/activty/overseawarehouse/oversea_app/app_oversea_02.jpg"></div>
    <div><img src="/static/images/activty/overseawarehouse/oversea_app/app_oversea_03.jpg"></div>
    <div><img src="/static/images/activty/overseawarehouse/oversea_app/app_oversea_04.jpg"></div>
    <!-- <div><img src="/static/images/activty/overseawarehouse/oversea_app/app_oversea_05.jpg"></div> -->
    <div><img src="/static/images/activty/overseawarehouse/oversea_app/app_oversea_06.jpg"></div>
    <div><img src="/static/images/activty/overseawarehouse/oversea_app/app_oversea_07.jpg"></div>
    <div><img src="/static/images/activty/overseawarehouse/oversea_app/app_oversea_08.jpg"></div>
    <div><img src="/static/images/activty/overseawarehouse/oversea_app/app_oversea_09.jpg"><span @click="ShippingFee"></span></div>
  </div>
</template>
<script>
export default {
  name: '',
  components: {},
  data() {
    return {}
  },
  watch: {},
  mounted() {},
  created() {
    this.$store.commit('SET_HEADER_TITLE', this.$t('title.processIntroduction'));
  },
  methods: {
 ShippingFee(){
  let that = this
      let ua = navigator.userAgent.toLowerCase();
      console.log('ua',ua)
      //android终端
      let isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1|| ua.indexOf('android') > -1|| ua.indexOf('adr') > -1;
      console.log('isAndroid',isAndroid)
      //ios终端
      let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

      let data = { "status": 0, "type": 1 }
      if (!isAndroid) {
        //ios
        console.log(" 我是ios")
        //这里是和IOS商量好的写法，调用IOS的finishActivity方法
        try {
          window.webkit.messageHandlers.PayShippingFee.postMessage(data)
        } catch (error) {
          console.log('WKWebView post message');
        }
      } else if(isAndroid){
        //android
        console.log("我是android",JSON.stringify(data));
        //这里是和安卓商量好的写法，调用安卓的finishActivity方法
        //android.PayCallback('我是android测试传值');           
        android.PayShippingFee(JSON.stringify(data));           
      }
    }
  },
}

</script>
<style scoped>
.oversea img {
  width: 100%;
  display: block;
  overflow: hidden;
}

.oversea>div {
  position: relative;
}

.oversea>div>span {
  position: absolute;    
  width: 93vw;
    height: 11vw;
    bottom: 3vw;
    right: 3vw;
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// src/components/activity/activitydetail.vue